import { MenuItem } from './menu-item';
import { Permission, hasPerm } from '../auth/permission.enum';
import { SidebarService } from './sidebar.service';
import { ConfigModulos } from 'app/models/configmodulos.model';
import { TranslateService } from '@ngx-translate/core';
import { TipoDocumentoAdmin } from 'app/models/tipo-documento-admin.model';
import { Injectable } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { isContaPacAutonoma } from 'app/utils/licenca.utils';

@Injectable({ providedIn: 'root' })
export class MenuRoutes {
  private menuItems: Array<MenuItem>;
  private configModulos: ConfigModulos;
  private ehMulticonta: boolean = false;
  tenant: any;
  user: any;
  identifierTenant: any;
  translate: TranslateService;
  private tipoDocAdmin: Array<TipoDocumentoAdmin>;
  private tdaLeiDados: TipoDocumentoAdmin;

  public createRoutes(
    sidebarService: SidebarService,
    configModulos: ConfigModulos
  ): any[] {
    this.translate = sidebarService.translate;
    this.configModulos = configModulos;
    this.iniciarVariaveisDeValidacoes(sidebarService);
    this.reloadMenu();
    this.createCadastros();
    return this.menuItems;
  }

  public async iniciarVariaveisDeValidacoes(sidebarService: SidebarService) {
    this.identifierTenant =
      sidebarService.tenantService.getOnlyNumberIdenfiersTenant();
    this.tenant = sidebarService.tenantService.getTenantStorage();
    this.user = sidebarService.authService.getUsuarioStorage();
    this.ehMulticonta = sidebarService.contaService.getMultiContaStorage();
    this.tipoDocAdmin = await sidebarService.tipoDocAdmService
      .getLocale()
      .toPromise();
    this.tdaLeiDados = this.tipoDocAdmin.find(this.isDocumentoLeiDados);
  }

  private isDocumentoLeiDados(doc: TipoDocumentoAdmin) {
    return doc.tipo === 'LEI_DADOS';
  }

  private reloadMenu() {
    this.menuItems = new Array<MenuItem>();
  }

  private createCadastros() {
    const home = new MenuItem(marker('Home'));
    home
      .setPath('/home/')
      .setIcon('centericon centericon-home')
      .setShow(hasPerm(Permission.PESSOA_READ));

    const inicioIntegrador = new MenuItem(marker('INICIO'));
    inicioIntegrador
      .setPath('/integrador/inicio/')
      .setIcon('centericon centericon-recados')
      .setShow(
        !this.possuiTenant() &&
        this.ehIntegrador() &&
        (hasPerm(Permission.CONTA_CREATE) || hasPerm(Permission.INTEGRADOR_RECADO_READ))
      );

    const integrador = new MenuItem(marker('Integradores'));
    integrador
      .setPath('/integrador/list-integrador')
      .setIcon('centericon centericon-integradores')
      .setShow(hasPerm(Permission.INTEGRADOR_CREATE));

    const subIntegrador = new MenuItem(marker('USUARIOS'));
    subIntegrador
      .setPath('/sub-integrador/list-sub-integrador')
      .setIcon('centericon centericon-pessoas')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)
      );

    const relatorioLgpdDistribuidor = new MenuItem(marker('LGPD'));
    relatorioLgpdDistribuidor
      .setPath('/relatorio/relatorio-lgpd-distribuidor')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(hasPerm(Permission.INTEGRADOR_CREATE));

    const relatorioLgpd = new MenuItem(marker('Relatórios'));
    relatorioLgpd
      .setTenant(true)
      .setIcon('centericon centericon-relatorios')
      .setClass('has-sub')
      .setShow(hasPerm(Permission.INTEGRADOR_CREATE));

    const conta = new MenuItem(marker('Contas'));
    conta
      .setPath('/conta/list-conta')
      .setIcon('centericon centericon-database')
      .setShow(!this.possuiTenant() && hasPerm(Permission.CONTA_READ));

    const contrato = new MenuItem(marker('Contratos'));
    contrato
      .setPath('/contrato/list-contrato')
      .setIcon('centericon centericon-contratos')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)
      );

    const sms = new MenuItem(marker('SMS'));
    sms
      .setPath('/integrador/sms-view')
      .setIcon('centericon centericon-sms')
      .setShow(
        hasPerm(Permission.INTEGRADOR_READ) &&
          this.ehIntegrador() &&
          this.configSmsHabilitatada()
      );

    const gestaoPreCadastros = new MenuItem(marker('GESTAO_PRE_CADASTROS'));
    gestaoPreCadastros
      .setPath('/gestao-pre-cadastros/list-pre-cadastros')
      .setIcon('centericon centericon-pessoas-plus')
      .setShow(!this.possuiTenant() && hasPerm(Permission.CONTA_CREATE))
      .setPointAttention(true);

    const configuracaoIntegrador = new MenuItem(marker('Configurações'));
    configuracaoIntegrador
      .setClass('has-sub')
      .setIcon('centericon centericon-configuracoes')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)
      );

    const customizacaoIntegrador = new MenuItem(marker('Customização'));
    customizacaoIntegrador
      .setPath('/integrador/custom-skin-integrador')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)
      );

    const autenticacao2FA = new MenuItem(marker('Autenticação'));
    autenticacao2FA
      .setPath('/integrador/config-autenticacao')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)
      );

    const addWhatsAppComponent = new MenuItem(marker('WhatsApp'));
    addWhatsAppComponent
      .setPath('/integrador/add-whatsapp')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)
      );

    const redirectShield = new MenuItem(marker('Segware Shield'));
    redirectShield
      .setPath('/integrador/shield')
      .setIcon('centericon centericon-segware-shield')
      .setShow(!this.possuiTenant() && this.ehIntegrador());

    const suporte = new MenuItem(marker('Suporte'));
    suporte
      .setClass('has-sub')
      .setIcon('icon-menu-suporte')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)
      );

    const modoDebug = new MenuItem(marker('CAPTURA_TELA'));
    modoDebug
      .setPath('/modo-debug/list-modo-debug')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)
      )
      .setNewFeature(true);

    suporte.submenu.push(modoDebug);

    const recadosIntegrador = new MenuItem(marker('Recados'));
    recadosIntegrador
      .setPath('/integrador/recado/list-recado/')
      .setIcon('centericon centericon-recados')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_RECADO_READ));

    const addPreCadastroComponent = new MenuItem(marker('Pré-cadastro'));
    addPreCadastroComponent
      .setPath('/integrador/add-pre-cadastro')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ));

    const auditoria = new MenuItem(marker('Auditoria'));
    auditoria
      .setIcon('centericon centericon-auditoria')
      .setClass('has-sub')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)
      );

    const logNotificacao = new MenuItem(marker('Integração PSIM'));
    logNotificacao
      .setPath('/log-notificacao/list-log-notificacao/')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)
      );

    const logDispositivo = new MenuItem(marker('Dispositivos'));
    logDispositivo
      .setPath('/log-notificacao/list-log-dispositivos/')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)
      );

    const logOperacoes = new MenuItem(marker('Log de Operações'));
    logOperacoes
      .setPath('/log-operacoes/list-log-operacoes/')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(this.habilitarLogOperacoes());

    const logWebhook = new MenuItem(marker('Webhook'));
    logWebhook
      .setPath('/log-webhook/list-log-webhook/')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)
      );

    const logEventoPsimErro = new MenuItem(marker('Descartes PSIM'));
    logEventoPsimErro
      .setPath('/log-evento-psim-erro/list-log-evento-psim-erro/')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)
      );

    const versoesApps = new MenuItem(marker('Versões APPs'));
    versoesApps
      .setPath('/versao-app-loja/list-versao-app-loja')
      .setTenant(false)
      .setIcon('centericon centericon-subitem-mais')
      .setShow(!this.possuiTenant() && this.ehSuperUsuario());

    const logsErros = new MenuItem(marker('Log de erros'));
    logsErros
      .setPath('/log-consulta-erro')
      .setTenant(false)
      .setIcon('centericon centericon-subitem-mais')
      .setShow(!this.possuiTenant() && this.ehSuperUsuario());

    const relatorios = new MenuItem(marker('Relatórios'));
    relatorios
      .setTenant(true)
      .setIcon('centericon centericon-relatorios')
      .setClass('has-sub')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.CONTA_READ)
      );

    const relatorioAcesso = new MenuItem(marker('Primeiro acesso'));
    relatorioAcesso
      .setPath('/relatorio/relatorio-primeiro-acesso')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.CONTA_READ)
      );

    const relatorioChamadas = new MenuItem(marker('Chamadas'));
    relatorioChamadas
      .setPath('/relatorio/relatorio-chamadas-integrador')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        !this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.CONTA_READ)
      );

    const relatorioLgpdIntegrador = new MenuItem(marker('LGPD'));
    relatorioLgpdIntegrador
      .setPath('/relatorio/relatorio-lgpd-integrador')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        (!this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)) ||
          hasPerm(Permission.INTEGRADOR_READ)
      );

    const lgpd = new MenuItem(
      this.tdaLeiDados ? this.tdaLeiDados.descricao : 'LGPD'
    );
    lgpd
      .setIcon('centericon centericon-lgpd')
      .setClass('has-sub')
      .setShow(
        (!this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)) ||
          hasPerm(Permission.INTEGRADOR_READ)
      );

    const lgpdTermosUso = new MenuItem(marker('Termos de uso'));
    lgpdTermosUso
      .setPath('/lgpd/list-lgpd-termos-uso/')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        (!this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)) ||
          hasPerm(Permission.INTEGRADOR_READ)
      );

    const lgpdPoliticaPrivacidade = new MenuItem(
      marker('Política de privacidade')
    );
    lgpdPoliticaPrivacidade
      .setPath('/lgpd/list-lgpd-politica-privacidade/')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        (!this.possuiTenant() &&
          this.ehIntegrador() &&
          hasPerm(Permission.INTEGRADOR_READ)) ||
          hasPerm(Permission.INTEGRADOR_READ)
      );

    relatorios.submenu.push(relatorioChamadas);
    relatorios.submenu.push(relatorioAcesso);
    relatorios.submenu.push(relatorioLgpdIntegrador);
    configuracaoIntegrador.submenu.push(autenticacao2FA);
    configuracaoIntegrador.submenu.push(customizacaoIntegrador);
    configuracaoIntegrador.submenu.push(addWhatsAppComponent);
    configuracaoIntegrador.submenu.push(addPreCadastroComponent);

    if(!this.isLicencaAccessOnPro() || !this.ehIntegrador()) {
      this.menuItems.push(home);
    }

    this.menuItems.push(inicioIntegrador);
    this.menuItems.push(conta);
    this.menuItems.push(subIntegrador);
    this.menuItems.push(contrato);
    this.menuItems.push(sms);
    this.menuItems.push(gestaoPreCadastros);
    this.menuItems.push(recadosIntegrador);
    this.menuItems.push(configuracaoIntegrador);

    auditoria.submenu.push(logNotificacao);
    auditoria.submenu.push(logDispositivo);
    auditoria.submenu.push(logOperacoes);
    auditoria.submenu.push(logWebhook);
    auditoria.submenu.push(logEventoPsimErro);
    auditoria.submenu.push(versoesApps);
    auditoria.submenu.push(logsErros);
    this.menuItems.push(auditoria);

    this.criarMenusQuePrecisamDoTenant();
    this.menuItems.push(integrador);
    this.menuItems.push(relatorios);

    lgpd.submenu.push(lgpdTermosUso);
    lgpd.submenu.push(lgpdPoliticaPrivacidade);
    this.menuItems.push(lgpd);

    relatorioLgpd.submenu.push(relatorioLgpdDistribuidor);
    this.menuItems.push(relatorioLgpd);
    this.menuItems.push(redirectShield);
    this.menuItems.push(suporte);
  }

  private isLicencaAccessOnPro(): boolean {
    if (this.user?.superUsuario) {
      return false;
    }

    const tipo = this.tenant?.tipoLicenca;
    return tipo && (tipo === 'ACCESS_ON' || tipo === 'ACCESS_PRO');
  }

  private isPacAutonomo(): boolean {
    return isContaPacAutonoma(this.tenant);
  }

  private criarMenusQuePrecisamDoTenant() {
    if (this.isLicencaAccessOnPro() && this.ehIntegrador()) {
      return;
    }

    const assembleia = new MenuItem(marker('Assembleia'));
    assembleia
      .setPath('/assembleia/list-assembleia')
      .setIcon('centericon centericon-assembleia')
      .setShow(!this.ehIntegrador() && hasPerm(Permission.ASSEMBLEIA_READ));

    const migracao = new MenuItem(marker('Migração'));
    migracao
      .setPath('/migracao')
      .setTenant(true)
      .setIcon('centericon centericon-migracao')
      .setShow(this.possuiTenant() && this.ehSuperUsuario());

    const unidades = new MenuItem(marker('Unidades'));
    unidades
      .setPath('/unidade/list-unidade')
      .setTenant(true)
      .setIcon('centericon centericon-unidades')
      .setShow(hasPerm(Permission.UNIDADE_READ));

    const pessoa = new MenuItem(marker('Pessoas'));
    pessoa
      .setPath('/pessoa/list-pessoa/')
      .setTenant(true)
      .setIcon('centericon centericon-pessoas')
      .setShow(hasPerm(Permission.PESSOA_CREATE));

    const inquilino = new MenuItem(marker('Aluguel'));
    inquilino
      .setPath('/inquilino/list-inquilino')
      .setTenant(true)
      .setIcon('centericon centericon-home')
      .setShow(
        this.possuiTenant() && (
          this.ehIntegrador() ||
          this.ehAdministrador() ||
          hasPerm(Permission.INQUILINO_READ)
        )
      );

    const previsaoVisita = new MenuItem(marker('Previsões de visita'));
    previsaoVisita
      .setPath('/portaria/list-portaria')
      .setIcon('centericon centericon-previsoes_de_visita')
      .setShow(this.isHabilitarPrevisaoVisita());

    const grupoPessoa = new MenuItem(marker('Grupos'));
    grupoPessoa
      .setPath('/grupo-pessoa/list-grupo-pessoa')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(this.possuiTenant() && hasPerm(Permission.GRUPO_READ));

    const cadastros = new MenuItem(marker('Cadastros'));
    cadastros
      .setTenant(true)
      .setIcon('centericon centericon-cadastros')
      .setClass('has-sub')
      .setShow(hasPerm(Permission.PESSOA_READ));

    const agendamento = new MenuItem(marker('Agendamentos'));
    agendamento
      .setPath('/agendamento/list-agendamento/')
      .setIcon('centericon centericon-input_data')
      .setShow(
        !this.ehIntegrador() && hasPerm(Permission.AGENDAMENTO_PROPRIO_READ)
      );

    const recados = new MenuItem(marker('Recados'));
    recados
      .setPath('/recado/list-recado/')
      .setIcon('centericon centericon-recados')
      .setShow(!this.ehIntegrador() && hasPerm(Permission.RECADO_READ));

    const chamado = new MenuItem(marker('Ocorrências'));
    chamado
      .setPath('/chamado/list-chamado/')
      .setTenant(true)
      .setIcon('centericon centericon-ocorrencias')
      .setShow(!this.ehIntegrador() && hasPerm(Permission.CHAMADO_READ));

    const correspondencia = new MenuItem(marker('Correspondências'));
    correspondencia
      .setPath('/correspondencia/list-correspondencias/')
      .setIcon('centericon centericon-correspondencias')
      .setShow(
        !this.ehIntegrador() && hasPerm(Permission.CORRESPONDENCIA_CREATE)
      );

    const correspondenciasUnidade = new MenuItem(marker('Correspondências'));
    correspondenciasUnidade
      .setPath('/correspondencia/list-correspondencias-unidade/')
      .setIcon('centericon centericon-correspondencias')
      .setShow(
        hasPerm(Permission.CORRESPONDENCIA_READ) &&
          !hasPerm(Permission.CORRESPONDENCIA_CREATE)
      );

    const documentos = new MenuItem(marker('Documentos'));
    documentos
      .setPath('/documento/list-documentos/')
      .setIcon('centericon centericon-documentos')
      .setShow(hasPerm(Permission.DOCUMENTO_READ));

    const manutencaoPreventiva = new MenuItem(marker('Manutenção'));
    manutencaoPreventiva
      .setPath('/manutencao-preventiva/list-manutencao-preventiva/')
      .setIcon('centericon centericon-manutencao_preventiva')
      .setShow(
        this.possuiTenant() && hasPerm(Permission.MANUTENCAO_PREVENTIVA_READ)
      );

    const enquetes = new MenuItem(marker('ENQUETES'));
    enquetes
      .setPath('/enquete/list-enquetes/')
      .setIcon('centericon centericon-enquete')
      .setShow(hasPerm(Permission.ENQUETE_READ));

    const portariaFuncionario = new MenuItem(marker('Portaria'));
    portariaFuncionario
      .setPath('/portaria-funcionario/list-portaria-funcionario/')
      .setTenant(true)
      .setIcon('centericon centericon-portaria')
      .setShow(!this.ehIntegrador() && hasPerm(Permission.PORTARIA_READ));

    const cameras = new MenuItem(marker('Câmeras'));
    cameras
      .setPath('/cameras/list-cameras/')
      .setTenant(true)
      .setIcon('centericon centericon-subitem-mais')
      .setShow(hasPerm(Permission.CAMERA_READ));

    const camerasMenu = new MenuItem(marker('Câmeras'));
    camerasMenu
      .setPath('/cameras/list-cameras-menu/')
      .setTenant(true)
      .setIcon('centericon centericon-cameras')
      .setShow(
        !this.ehIntegrador() &&
          this.isDGUARDHabilitado() &&
          hasPerm(Permission.CAMERA_READ)
      );

    const configsituatorMenu = new MenuItem(marker('Configurações'));
    configsituatorMenu
      .setIcon('centericon centericon-configuracoes')
      .setClass('has-sub')
      .setShow(hasPerm(Permission.CONFIGURAR_PSIM_CREATE));

    const configuracoes = new MenuItem(marker('Configurações'));
    configuracoes
      .setPath('/configuracoes/list-configuracoes/')
      .setTenant(true)
      .setIcon('centericon centericon-configuracoes')
      .setShow(
        !this.ehIntegrador() && hasPerm(Permission.CONFIGURACOES_CREATE)
      );

    const locker = new MenuItem(marker('Locker'));
    locker
      .setPath('/locker/app-locker/')
      .setTenant(true)
      .setIcon('centericon centericon-locker')
      .setShow(this.possuiTenant() && hasPerm(Permission.DISPOSITIVO_READ));

    const configCameras = new MenuItem(marker('Conexões'));
    configCameras
      .setPath('/config-cameras/list-configcameras/')
      .setTenant(true)
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        this.possuiTenant() && hasPerm(Permission.CONFIGURAR_CAMERA_READ)
      );

    const lpr = new MenuItem(marker('LPR'));
    lpr
      .setPath('/cameras/lpr-cameras/')
      .setTenant(true)
      .setIcon('centericon centericon-subitem-mais')
      .setShow(this.possuiTenant() && hasPerm(Permission.CAMERA_READ));

    const psim = new MenuItem(marker('PSIM'));
    psim
      .setPath('/submenu-psim/')
      .setTenant(true)
      .setIcon('centericon centericon-psim')
      .setClass('has-sub')
      .setShow(
        this.possuiTenant() && this.isHabilitarPSIM() && !this.isPacAutonomo()
      );

    const vms = new MenuItem(marker('VMS'));
    vms
      .setPath('/submenu-cameras/')
      .setTenant(true)
      .setIcon('centericon centericon-camera_vms')
      .setClass('has-sub')
      .setShow(this.possuiTenant() && this.isHabilitarVMS());

    const softPhone = new MenuItem(marker('SoftPhone'));
    softPhone
      .setPath('/softphone/')
      .setTenant(true)
      .setIcon('')
      .setClass('')
      .setShow(this.possuiTenant());

    const cftv = new MenuItem(marker('CFTV'));
    cftv
      .setTenant(true)
      .setPath('/cftv/list-cftv')
      .setIcon('centericon centericon-camera_cftv')
      .setShow(this.possuiTenant() && this.isHabilitarCftv());

    const psimConfig = new MenuItem(marker('Conexão'));
    psimConfig
      .setPath('/config-psim/step-configpsim/')
      .setTenant(true)
      .setIcon('centericon centericon-subitem-mais')
      .setShow(hasPerm(Permission.CONFIGURAR_PSIM_READ));

    const conexaoBiMulticonta = new MenuItem(marker('Conexão BI'));
    conexaoBiMulticonta
      .setPath('/config_bi_multiconta/')
      .setTenant(true)
      .setIcon('centericon centericon-subitem-mais')
      .setShow(this.isMulticonta());

    const psimEventos = new MenuItem(marker('Eventos'));
    psimEventos
      .setPath('/evento/list-psim-eventos/')
      .setTenant(true)
      .setIcon('centericon centericon-subitem-mais')
      .setShow(hasPerm(Permission.EVENTO_READ));

    const configuracoesConta = new MenuItem(marker('Conta'));
    configuracoesConta
      .setPath('/configuracoes/list-configuracoes-conta/')
      .setTenant(true)
      .setIcon('centericon centericon-subitem-mais')
      .setShow(hasPerm(Permission.CONFIGURACOES_CREATE));

    const scondkey = new MenuItem(marker('Key'));
    scondkey
      .setPath('/config-scond/list-key/')
      .setTenant(true)
      .setIcon('centericon centericon-subitem-mais')
      .setShow(hasPerm(Permission.CONFIGURAR_PSIM_READ));

    const chavevirtual = new MenuItem(marker('Chave virtual'));
    chavevirtual
      .setPath('/config-scond/list-config-zonas/')
      .setTenant(true)
      .setIcon('centericon centericon-subitem-mais')
      .setShow(hasPerm(Permission.CONFIGURAR_PSIM_READ));

    const modulos = new MenuItem(marker('Integrações'));
    modulos
      .setPath('/configmodulos/')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(hasPerm(Permission.CONFIGURACOES_READ));

    const areaComum = new MenuItem(marker('Área comum'));
    areaComum
      .setPath('/area-comum/list-area-comum/')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(hasPerm(Permission.AREA_COMUM_READ));

    const estacionamento = new MenuItem(marker('Estacionamentos'));
    estacionamento
      .setPath('/estacionamento/list-estacionamento/')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(hasPerm(Permission.ESTACIONAMENTO_READ));

    const fornecedor = new MenuItem(marker('Fornecedor'));
    fornecedor
      .setPath('/fornecedor/list-fornecedor/')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(hasPerm(Permission.FORNECEDORES_READ));

    const categoriaChamado = new MenuItem(marker('Categoria de ocorrência'));
    categoriaChamado
      .setPath('/chamado/list-categoria-chamado/')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        this.possuiTenant() && hasPerm(Permission.CATEGORIA_CHAMADO_READ)
      );

    const relatorios = new MenuItem(marker('Relatórios'));
    relatorios
      .setTenant(true)
      .setIcon('centericon centericon-relatorios')
      .setClass('has-sub')
      .setShow(this.possuiTenant());

    const relatorioChamado = new MenuItem(marker('Ocorrência'));
    relatorioChamado
      .setPath('/relatorio/relatorio-chamado/')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(this.possuiTenant() && hasPerm(Permission.CHAMADO_UPDATE));

    const relatorioAgendamento = new MenuItem(marker('Agendamentos'));
    relatorioAgendamento
      .setPath('/relatorio/relatorio-agendamentos/')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        this.possuiTenant() &&
          (hasPerm(Permission.AREA_COMUM_CREATE) ||
            hasPerm(Permission.AREA_COMUM_UPDATE))
      );

    const relatorioPortaria = new MenuItem(marker('Portaria'));
    relatorioPortaria
      .setPath('/relatorio/relatorio-portaria/')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(this.possuiTenant() && hasPerm(Permission.PORTARIA_READ));

    const relatorioPrevisaoVisita = new MenuItem(marker('Previsão de visita'));
    relatorioPrevisaoVisita
      .setPath('/relatorio/relatorio-previsao-visita')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        this.possuiTenant() && hasPerm(Permission.PREVISAO_VISITA_CREATE)
      );

    const relatorioAcionamentos = new MenuItem(marker('ACIONAMENTOS'));
    relatorioAcionamentos
      .setPath('/relatorio/relatorio-acionamentos')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        this.possuiTenant() && hasPerm(Permission.RELATORIO_ABERTURA_PORTA)
      );

    const relatorioPrimeiroAcessoConta = new MenuItem(marker('Primeiro acesso'));
    relatorioPrimeiroAcessoConta
      .setPath('/relatorio/relatorio-primeiro-acesso-conta')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        this.possuiTenant() &&
          hasPerm(Permission.RELATORIO_PRIMEIRO_ACESSO_CREATE)
      );

    const relatorioChamadas = new MenuItem(marker('Chamadas'));
    relatorioChamadas
      .setPath('/relatorio/relatorio-chamadas')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        this.possuiTenant() &&
          this.isVoip() &&
          hasPerm(Permission.RELATORIO_REGISTRO_CHAMADA)
      );

    const relatorioUnidades = new MenuItem(marker('Unidades'));
    relatorioUnidades
      .setPath('/relatorio/relatorio-unidades')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(this.possuiTenant() && hasPerm(Permission.RELATORIO_UNIDADE));

    const relatorioVeiculos = new MenuItem(marker('Veiculos'));
    relatorioVeiculos
      .setPath('/relatorio/relatorio-veiculos')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        this.possuiTenant() && hasPerm(Permission.RELATORIO_VEICULO_READ)
      );

    const timelineEventos = new MenuItem(marker('Timeline'));
    timelineEventos
      .setPath('/timeline-eventos')
      .setIcon('centericon centericon-timeline')
      .setShow(!this.ehIntegrador() && this.psimHabilitado());

    const entregaAutonoma = new MenuItem(marker('ENTREGA_AUTONOMA'));
    entregaAutonoma
      .setPath('/locker/list-entrega-autonoma')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(
        this.possuiTenant() &&
        this.configModulos.habilitarEntregaAutonoma &&
        hasPerm(Permission.ENTREGA_AUTONOMA_READ)
      );

    const zeladorIA = new MenuItem(marker('ZELADOR_IA'));
    zeladorIA
      .setPath('/zelador-ia/')
      .setTenant(true)
      .setIcon('centericon centericon-zelador-ia')
      .setShow(
        this.possuiTenant() &&
        this.configModulos.habilitarZeladorIA &&
        hasPerm(Permission.ZELADOR_IA_READ)
      )
      .setNewFeature(true);

    psim.submenu.push(psimConfig);
    psim.submenu.push(conexaoBiMulticonta);
    psim.submenu.push(psimEventos);
    this.addSubMenuNotificacaoTipoEvento(psim);
    psim.submenu.push(scondkey);
    psim.submenu.push(chavevirtual);

    vms.submenu.push(configCameras);
    vms.submenu.push(cameras);
    vms.submenu.push(lpr);

    configsituatorMenu.submenu.push(configuracoesConta);
    configsituatorMenu.submenu.push(modulos);

    cadastros.submenu.push(areaComum);
    cadastros.submenu.push(grupoPessoa);
    cadastros.submenu.push(estacionamento);
    cadastros.submenu.push(fornecedor);
    cadastros.submenu.push(categoriaChamado);
    cadastros.submenu.push(entregaAutonoma);

    relatorios.submenu.push(relatorioAcionamentos);
    relatorios.submenu.push(relatorioAgendamento);
    relatorios.submenu.push(relatorioChamadas);
    relatorios.submenu.push(relatorioChamado);
    relatorios.submenu.push(relatorioPortaria);
    relatorios.submenu.push(relatorioPrevisaoVisita);
    relatorios.submenu.push(relatorioPrimeiroAcessoConta);
    relatorios.submenu.push(relatorioUnidades);
    relatorios.submenu.push(relatorioVeiculos);

    this.menuItems.push(migracao);
    this.menuItems.push(unidades);
    this.menuItems.push(pessoa);
    this.menuItems.push(inquilino);
    this.menuItems.push(cadastros);
    this.menuItems.push(agendamento);
    this.menuItems.push(recados);
    this.menuItems.push(chamado);
    this.menuItems.push(correspondencia);
    this.menuItems.push(correspondenciasUnidade);
    this.menuItems.push(documentos);
    this.menuItems.push(manutencaoPreventiva);
    this.menuItems.push(zeladorIA);
    this.menuItems.push(assembleia);
    this.menuItems.push(enquetes);
    this.menuItems.push(timelineEventos);
    this.menuItems.push(portariaFuncionario);
    this.menuItems.push(vms);
    this.menuItems.push(cftv);
    this.menuItems.push(camerasMenu);
    this.menuItems.push(psim);
    this.menuItems.push(locker);
    this.menuItems.push(configuracoes);
    this.menuItems.push(configsituatorMenu);
    this.menuItems.push(previsaoVisita);
    this.addMenuVoip();
    this.addMenuAcessos();
    this.menuItems.push(relatorios);
  }

  private addMenuAcessos() {
    if (!this.possuiTenant()) return;

    const pacAutonomo = this.isPacAutonomo();

    const podeVerAcessoPac =
      pacAutonomo &&
      (this.ehIntegrador() ||
        this.ehAdministrador() ||
        hasPerm(Permission.EQUIPAMENTO_PAC_READ));
    const podeVerAcessoLegado =
      !pacAutonomo && this.ehIntegrador() && this.tenant.controleAcesso;

    if (!podeVerAcessoPac && !podeVerAcessoLegado) return;

    const acessos = new MenuItem(
      pacAutonomo ? marker('CONTROLE_DE_ACESSO') : marker('AUTONOMO_TITULO')
    );
    acessos
      .setTenant(true)
      .setIcon(
        pacAutonomo
          ? 'centericon centericon-controle-acesso'
          : 'novoLayout centericon-arrows-minimize'
      )
      .setClass('has-sub')
      .setShow(true);

    this.menuItems.push(acessos);

    if (pacAutonomo) {
      this.addSubMenusAcessoPacAutonomo(acessos);
      return;
    }

    const dispositivo = new MenuItem(marker('Dispositivos'));
    dispositivo
      .setPath('/hub/list-equipamento-hub/')
      .setTenant(true)
      .setIcon('centericon centericon-subitem-mais')
      .setShow(hasPerm(Permission.DISPOSITIVO_READ));

    acessos.submenu.push(dispositivo);

    const porta = new MenuItem(marker('RELES'));
    porta
      .setPath('/hub/porta-hub')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(true);

    const perfis = new MenuItem(marker('Perfis'));
    perfis
      .setPath('/perfil-acesso/list-perfil-acesso')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(true);

    const horarios = new MenuItem(marker('Horários'));
    horarios
      .setPath('/horarios/list-horarios')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(true);

    const credenciais = new MenuItem(marker('Credenciais'));
    credenciais
      .setPath('/credencial/list-credenciais')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(true);

    const statusHub = new MenuItem(marker('STATUS_DISPOSITIVO'));
    statusHub
      .setPath('/hub/status-equipamento-hub')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(true);

    const logsHub = new MenuItem(marker("Log's"));
    logsHub
      .setTenant(true)
      .setIcon('centericon centericon-subitem-mais')
      .setClass('has-sub')
      .setShow(true);

    const logEventosHub = new MenuItem(marker('Eventos'));
    logEventosHub
      .setPath('/hub/log-eventos-hub')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(true);

    const logSincronizacaoHub = new MenuItem(marker('SINCRONIZACAO'));
    logSincronizacaoHub
      .setPath('/hub/log-sincronizacao-hub')
      .setIcon('centericon centericon-subitem-mais')
      .setShow(true);

    logsHub.submenu.push(logEventosHub);
    logsHub.submenu.push(logSincronizacaoHub);

    acessos.submenu.push(porta);
    acessos.submenu.push(horarios);
    acessos.submenu.push(perfis);
    acessos.submenu.push(credenciais);
    acessos.submenu.push(statusHub);
    acessos.submenu.push(logsHub);
  }

  private addSubMenusAcessoPacAutonomo(acessos: MenuItem) {
    const gestorDaConta = this.ehIntegrador() || this.ehAdministrador();

    if (hasPerm(Permission.EQUIPAMENTO_PAC_READ)) {
      const equipamentos = new MenuItem(marker('EQUIPAMENTOS'));
      equipamentos
        .setTenant(false)
        .setPath('/equipamento-pac/list-equipamento-pac')
        .setIcon('centericon centericon-subitem-mais')
        .setShow(true);

      acessos.submenu.push(equipamentos);
    }

    if (gestorDaConta) {
      const perfisAcesso = new MenuItem(marker('PERFIS_DE_ACESSO'));
      perfisAcesso
        .setPath('/perfil-acesso/list-perfil-acesso')
        .setIcon('centericon centericon-subitem-mais')
        .setShow(true);

      const credenciais = new MenuItem(marker('Credenciais'));
      credenciais
        .setPath('/credencial/list-credenciais')
        .setIcon('centericon centericon-subitem-mais')
        .setShow(true);

      acessos.submenu.push(perfisAcesso);
      acessos.submenu.push(credenciais);
    }

    if (gestorDaConta && hasPerm(Permission.CONFIGURAR_PSIM_READ)) {
      const notificacoes = new MenuItem(marker('Notificações'));
      notificacoes
        .setPath('/notificacao-tipo-evento/list-notificacao-tipo-evento/')
        .setTenant(true)
        .setIcon('centericon centericon-subitem-mais')
        .setShow(true);

      acessos.submenu.push(notificacoes);
    }

    if (gestorDaConta && hasPerm(Permission.CONVITE_VIRTUAL_READ)) {
      const conviteVirtual = new MenuItem(marker('CONVITE_VIRTUAL'));
      conviteVirtual
        .setPath('/convite-virtual')
        .setTenant(true)
        .setIcon('centericon centericon-subitem-mais')
        .setShow(true);

      acessos.submenu.push(conviteVirtual);
    }

    if (gestorDaConta && hasPerm(Permission.CHAVE_VIRTUAL_READ)) {
      const chaveVirtual = new MenuItem(marker('Chave Virtual'));
      chaveVirtual
        .setPath('/chave-virtual')
        .setTenant(true)
        .setIcon('centericon centericon-subitem-mais')
        .setShow(true);

      acessos.submenu.push(chaveVirtual);
    }
  }

  private addMenuVoip() {
    if (!this.possuiTenant() || !this.ehIntegrador() || !this.isVoip()) return;

    const voip = new MenuItem(marker('VOIP'));

    voip
      .setTenant(true)
      .setIcon('centericon centericon-voip')
      .setClass('has-sub')
      .setShow(true);

    this.menuItems.push(voip);

    if (this.isVoipSip()) {
      const configSIP = new MenuItem(marker('Configurações'));
      configSIP
        .setPath('/voip/config-voip')
        .setIcon('centericon centericon-subitem-mais')
        .setShow(true);

      voip.submenu.push(configSIP);

      const troncos = new MenuItem(marker('Troncos'));
      troncos
        .setPath('/voip/list-tronco')
        .setIcon('centericon centericon-subitem-mais')
        .setShow(true);

      voip.submenu.push(troncos);

      const dispositivoSip = new MenuItem(marker('Dispositivos'));
      dispositivoSip
        .setPath('/voip/list-dispositivo-sip')
        .setIcon('centericon centericon-subitem-mais')
        .setShow(true);

      voip.submenu.push(dispositivoSip);
    } else {
      const dispositivo = new MenuItem(marker('Dispositivos'));
      dispositivo
        .setPath('/equipamento/list-equipamento')
        .setTenant(true)
        .setIcon('centericon centericon-subitem-mais')
        .setShow(hasPerm(Permission.DISPOSITIVO_READ));

      voip.submenu.push(dispositivo);
    }
  }

  private addSubMenuNotificacaoTipoEvento(psim) {
    if (!(this.isSituatorNovaApi() && this.webhookHabilitado() || this.isSigma())) {
      return;
    }

    const notificacaoTipoEvento = new MenuItem(marker('Notificações'));
    notificacaoTipoEvento
      .setPath('/notificacao-tipo-evento/list-notificacao-tipo-evento/')
      .setTenant(true)
      .setIcon('centericon centericon-subitem-mais')
      .setShow(hasPerm(Permission.CONFIGURAR_PSIM_READ));
    3;

    psim.submenu.push(notificacaoTipoEvento);
  }

  private possuiTenant(): boolean {
    return this.tenant;
  }

  private isVoip(): boolean {
    return this.tenant.voipApp;
  }

  private isVoipSip(): boolean {
    return 'SIP' == this.tenant.tipoVoipApp;
  }

  private ehIntegrador(): boolean {
    return this.user.integrador;
  }

  private psimHabilitado(): boolean {
    const psimHabilitado = sessionStorage.getItem('psimHabilitado');
    return psimHabilitado === 'true';
  }

  private webhookHabilitado(): boolean {
    const psimHabilitado = sessionStorage.getItem('webhookHabilitado');
    return psimHabilitado === 'true';
  }

  private isSituatorNovaApi() {
    return (
      'SITUATOR_NOVA_API' == JSON.parse(sessionStorage.getItem('sistemaPSIM'))
    );
  }

  private isSigma() {
    return (
      'SIGMA' == JSON.parse(sessionStorage.getItem('sistemaPSIM'))
    );
  }

  private ehSuperUsuario(): boolean {
    if (this.user.superUsuario) {
      return true;
    }
    return false;
  }

  private habilitarLogOperacoes(): boolean {
    return !this.possuiTenant() && this.ehIntegrador() && hasPerm(Permission.INTEGRADOR_READ);
  }

  private configSmsHabilitatada(): boolean {
    if (this.user.smsHabilitado) {
      return true;
    }
    return false;
  }

  private isHabilitarPrevisaoVisita(): boolean {
    if (this.user.integrador || !this.user.possuiUnidadeAssociada) {
      return false;
    }
    return hasPerm(Permission.PREVISAO_VISITA_READ);
  }

  private isHabilitarPSIM() {
    return (
      this.ehIntegrador() &&
      this.configModulos &&
      this.configModulos.habilitarPSIM &&
      hasPerm(Permission.CONFIGURAR_PSIM_READ)
    );
  }

  private isHabilitarVMS() {
    return (
      this.ehIntegrador() &&
      this.isDGUARDHabilitado() &&
      hasPerm(Permission.CONFIGURAR_CAMERA_CREATE)
    );
  }

  private isHabilitarCftv() {
    return (
      this.ehIntegrador() &&
      this.configModulos &&
      this.configModulos.habilitarCftv
    );
  }

  private isDGUARDHabilitado() {
    return this.configModulos && this.configModulos.habilitarDGuard;
  }

  private isMulticonta() {
    return this.ehMulticonta;
  }

  private ehAdministrador(): boolean {
    return hasPerm(Permission.PESSOA_CREATE);
  }

}
